import { render } from "./CustomersPanel.vue?vue&type=template&id=3048b69f&scoped=true"
import script from "./CustomersPanel.vue?vue&type=script&lang=js"
export * from "./CustomersPanel.vue?vue&type=script&lang=js"

import "./CustomersPanel.vue?vue&type=style&index=0&id=3048b69f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3048b69f"]])

export default __exports__